import { EventBus } from "../../../plugins/eventBus";

const commonMethods = {
  data() {
    return {
      fields: { text: 'showName', value: 'value' },
      styles: {
        width: '400px',
        height: '600px',
        visible: false,
        model: true,
        zIndex: 1001
      },
      requestCommon: '/lte/ems/subscriber/mcs/requestCommonMicro',
      optionsUserType: [
        {
          showName: this.$t('MCS.all'),
          value: 0
        },
        {
          showName: this.$t('MCS.user'),
          value: 1
        },
        // {
        //   showName: this.$t('MCS.admin'),
        //   value: 2
        // },
        {
          showName: this.$t('MCS.au_vi'),
          value: 3
        },
        {
          showName: this.$t('MCS.dc'),
          value: 5
        },
        {
          showName: this.$t('MCS.mobile'),
          value: 7
        }
      ],
      optionsUserPrivilege: [
        {
          showName: this.$t('MCS.ordinaryUser'),
          value: '0'
        },
        {
          showName: this.$t('MCS.highUser'),
          value: '1'
        },
        {
          showName: this.$t('MCS.superUser'),
          value: '2'
        },
      ],
      optionsUserPriority: [
        {
          showName: '1',
          value: '1'
        },
        {
          showName: '2',
          value: '2'
        },
        {
          showName: '3',
          value: '3'
        },
        {
          showName: '4',
          value: '4'
        },
        {
          showName: '5',
          value: '5'
        },
        {
          showName: '6',
          value: '6'
        },
        {
          showName: '7',
          value: '7'
        }
      ],
      msg: {
        // cms
        addUser: 43000,
        modUser: 43001,
        delUser: 43002,
        qryUsers: 43003,
        qryModUser: 43004,

        addGroupList: 43005,
        modGroupList: 43006,
        delGroupList: 43007,
        qryGroupList: 43008,

        addBlackList: 43009,
        delBlackList: 43010,
        qryBlackList: 43011,

        addUserArea: 43012,
        modUserArea: 43013,
        delUserArea: 43014,
        qryUserArea: 43015,

        addAreaAuthorize: 43016,
        delAreaAuthorize: 43017,
        qryAreaAuthorize: 43018,
        // gms
        addGroup: 46080,
        modGroup: 46081,
        delGroup: 46082,
        qryGroups: 46083,

        qryModGroup: 46084,
        addGroupMember: 46085,
        modGroupMember: 46086,
        delGroupMember: 46087,
        qryGroupMember: 46088,

        addGroupSubordinate: 46089,
        modGroupSubordinate: 46090,
        delGroupSubordinate: 46091,
        qryGroupSubordinate: 46092,

        addGroupArea: 46093,
        delGroupArea: 46094,
        qryGroupArea: 46095,

        addGpsArea: 46096,
        modGpsArea: 46097,
        delGpsArea: 46098,
        qryGpsArea: 46099,

        addVpnId: 46100,
        modVpnId: 46101,
        delVpnId: 46102,
        qryVpnId: 46103,

        addPhssVpnSort: 46104,
        qryPhssVpnSort: 46105,

        addLdsVpn: 46106,
        modLdsVpn: 46107,
        delLdsVpn: 46108,
        qryLdsVpn: 46109,
      },
      regex: {
        //char: '^[a-zA-Z0-9\u4e00-\u9fa5]+$',
        char: '^[^\'\"\\;]+$',
        noMatchRegex: '^@_-@_-@_-@_-@_-@_$'
      },
      enterpriseDomain: 'mcs.com',
      productType: 1,
      errorCode: {
        breakLine: 'subscriber.9005'
      }
    };
  },
  methods: {
    /**
     *  cms
     */
    participantTypeFormatter(field, data) {
      let resShowName = '';
      this.optionsUserType.forEach((item) => {
        if (parseInt(item.value) === parseInt(data.userType)) {
          resShowName = item.showName;
        }
      });
      return resShowName;
    },

    voiceRegisterStatusFormatter(field, data) {
      return [this.$t('MCS.offline'), this.$t('MCS.online')][parseInt(data.mcpttRegisterStatus)];
    },

    videoRegisterStatusFormatter(field, data) {
      return [this.$t('MCS.offline'), this.$t('MCS.online')][parseInt(data.mcvideoRegisterStatus)];
    },

    dataRegisterStatusFormatter(field, data) {
      return [this.$t('MCS.offline'), this.$t('MCS.online')][parseInt(data.mcdataRegisterStatus)];
    },

    registerStatusFormatter(field, data) {
      return [this.$t('MCS.offline'), this.$t('MCS.online')][parseInt(data.registerStatus)];
    },

    stunStatusFormatter(field, data) {
      return [this.$t('MCS.working'), this.$t('MCS.stun'), this.$t('MCS.kill')][parseInt(data.stunStatus)];
    },

    /**
     *  gms
     */
    grouptypeFormatter(field, data) {
      return [this.$t('MCS.staticGroup'), this.$t('MCS.dynamicGroup'), this.$t('MCS.areaGroup')][parseInt(data.groupType)];
    },

    userPrivilegeFormatter(field, data) {
      console.log(data.userPrivilege);
      return [this.$t('MCS.ordinaryUser'), this.$t('MCS.highUser'), this.$t('MCS.superUser')][parseInt(data.userPrivilege)];
    },

    /**
     * common
     */

    // 拼写vo循环方法, 适用批量操作
    voCycleSpell(staticMap, dynamicMap, dynamicParamsLength) {
      const vo = [];
      for (let i = 0; i < dynamicParamsLength; i++) {
        const tempObj = {};
        staticMap.forEach((item, key) => {
          tempObj[key] = item;
        });
        dynamicMap.forEach((item, key) => {
          tempObj[key] = item[i];
        });
        vo.push(tempObj);
      }
      return vo;
    },

    utf8Length(inputStr, maxLength) {
      let totalLength = 0;
      /* 计算utf-8编码情况下的字符串长度 */
      for (let i = 0; i < inputStr.length; i++) {
        if (inputStr.charCodeAt(i) <= parseInt(0x7F)) {
          totalLength += 1;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
          totalLength += 2;
        } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
          totalLength += 3;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
          totalLength += 4;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
          totalLength += 5;
        } else {
          totalLength += 6;
        }
      }
      return totalLength <= maxLength;
    },

    $toast(type, content = '') {
      const $this = this;
      switch (type) {
        case 'success':
          EventBus.$emit('toast', { type: 'success', content: $this.$t('Common.tips.success') } );
          break;
        case 'failure':
          if (content === '') {
            content = $this.$t('Common.tips.failure');
          }
          EventBus.$emit('toast', { type: 'error', content: content } );
          break;
        default:
          EventBus.$emit('toast', { type: type, content: content } );
      }
    },

    commonResp(response) {
      try {
        const commonThis = this;
        if (response.data) {
          const respData = response.data;
          if (parseInt(respData.errorCode) === 0) {
            commonThis.$toast('success');
          } else {
            commonThis.$toast('failure', respData.errorString);
          }
        } else {
          console.log('subscriber error , resp = ', response);
        }
      } catch (e) { console.log('parse resp error.'); }
    },

    /**
     * 截取形如 a.b.c 的结果 返回 c
     */
    splitResult(result) {
      const arr = result.split('.');
      if (arr.length !== 3) {
        console.log('subsriber result error. ');
        return -1;
      } else if (arr.length === 3) {
        return arr[2];
      }
    },

    toInt(_value) {
      let _resVal = null;
      try {
        _resVal = parseInt(_value);
      } catch (e) {
        _resVal = _value;
        console.log('_value = ' + _value + 'parseInt error.');
      }
      return _resVal;
    }
  }
};
export default commonMethods;
